import { Paper, Table, TableContainer } from "@mui/material";
import { ReactNode } from "react";
import { styled } from "@mui/material/styles";

interface Props {
  className?: string;
  children: ReactNode;
}

export function StickyTable(props: Props) {
  return (
    <Styles className={props.className}>
      <TableContainer component={Paper}>
        <Table className="table" stickyHeader>
          {props.children}
        </Table>
      </TableContainer>
    </Styles>
  );
}

const Styles = styled("div")`
  .MuiTableContainer-root {
    max-height: 100%;
  }
  .MuiTableRow-root {
    &.odd {
      background-color: #f7f7f7;
    }
  }

  .MuiTableCell-stickyHeader {
    background-color: #fafafa;
  }
`;
